<template>
  <div :style="styles.wrapper(getCards)">
    <nav class="nav">
      <div></div>
      <!-- <div :style="styles.navInputWrapper">
          <span
            class="glyphicon glyphicon-search"
            :style="styles.navInputIcon"
          ></span>
          <input
            :style="styles.navInput"
            type="text"
            v-model="cardQuery"
            placeholder="search by card title"
          >
      </div>-->
      <div>
        <button class="button__action" @click="toggleNewCardModal">Create New Action Card</button>
      </div>
    </nav>
    <LibraryGrid v-if="checkCardsLoaded && getCards">
      <div class="view-explanation">
        <button class="toggle-cards button__action button__delete" @click="toggleDeleted()">{{showDeleted ? 'View Active Cards' : 'View Deleted Cards'}}</button>
        <h1>Action Cards</h1>
        <p>Action cards are issued to app users, alone or within a
          <router-link to="/sequences">sequence</router-link>, when certain conditions are met. Depending on the type of action card, these cards can deliver next steps, follow ups, general advice, and training media.
        </p>
      </div>
      <router-link
        :key="index"
        v-if="showDeleted ? card.deleted : !card.deleted"
        v-for="(card, index) in getCards"
        :to="'/cards/'+card._id"
        class="card-wrap"
      >
        <LibraryActionCard
          :slug="card.legacyName ? card.legacyName : ''"
          :cardTitle="card.displayName === 'Training Media' ? (card.mediaId ? card.mediaId.title : '') : card.displayName"
          :media="card.mediaId ? card.mediaId : null"
          :title="card.title ? card.title.intial : null"
          :callToAction="card.callToAction ? card.callToAction.intial : ''"
        />
      </router-link>
    </LibraryGrid>
    <Spinner v-if="loading"/>
  </div>
</template>

<script>
import Services from '../../services/Services';
import Spinner from '../general/Spinner';
import LibraryGrid from '../general/LibraryGrid';
import LibraryActionCard from '../general/LibraryActionCard';
import store from '../../store';
export default {
  name: 'cardLibrary',
  components: {
    LibraryGrid,
    LibraryActionCard,
    Spinner
  },
  computed: {
    checkCardsLoaded() {
      return store.getters.checkCardsReady;
    },
    getCards() {
      return store.getters.getCards;
    },
    getCardNames() {
      return Object.keys(store.getters.getCards);
    }
  },
  methods: {
    toggleNewCardModal() {
      store.commit('showCreateCardModal', true);
    },
    toggleDeleted() {
        this.showDeleted = !this.showDeleted;
    }
  },
  data() {
    return {
        loading: true,
      cardQuery: '',
      showDeleted: false,
      styles: {
        wrapper: loaded => ({
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: loaded ? 'flex-start' : 'center',
          alignItems: loaded ? 'flex-start' : 'center',
          height: '100vh',
          width: '100%'
        }),
        nav: {
          position: 'fixed',
          top: 0,
          left: '200px',
          right: 0,
          background: '#fff',
          boxShadow: '0 2px 5px 1px rgba(0,0,0,0.1)',
          height: '60px',
          zIndex: '99',
          padding: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInputWrapper: {
          flex: '0 0 auto',
          width: '250px',
          padding: '10px',
          background: '#f5f5f5',
          border: '1px solid #eee',
          borderRadius: '5px',
          overflow: 'hidden',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center'
        },
        navInput: {
          flex: '1',
          padding: '0',
          borderRadius: '0',
          border: '0',
          fontSize: '14px',
          background: '#f5f5f5'
        },
        navInputIcon: {
          margin: 'auto 10px auto 0',
          color: '#888'
          // fontSize: '1.25rem'
        },
        toggleUploadModalButton: {
          background: '#09a3ed',
          fontSize: '0.9em',
          color: '#fff',
          borderRadius: '5px',
          padding: '5px 10px 5px 5px',
          margin: 'auto 0 auto auto',
          border: '0',
          display: 'flex',
          flexFlow: 'row nowrap',
          alignItems: 'center',
          ':hover': {
            cursor: 'pointer',
            opacity: '0.9'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap',
          justifyContent: 'space-around'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '13px',
          textTransform: 'capitalize'
          // fontFamily: 'proxima_nova_ltsemibold'
        },
        cardTitle: {
          // fontFamily: 'proxima_nova_ltsemibold',
          // fontSize: '1.2rem'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40',
          width: '100%'
        },
        cardType: {
          margin: '20px auto 10px 20px',
          color: '#888'
        },
        backIcon: {
          margin: 'auto 5px auto auto',
          color: '#aaa'
        },
        actionType: {
          margin: '0 auto 20px 20px',
          fontSize: '1.5em'
        },
        tabWrap: {
          width: '100%',
          minHeight: '200px',
          margin: 0,
          display: 'flex',
          background: '#e8ffff',
          flexFlow: 'column nowrap'
        },
        tabList: {
          listStyle: 'none',
          display: 'flex',
          flexFlow: 'row nowrap',
          margin: 0,
          padding: 0
        },
        tab: {
          flex: '1',
          padding: '10',
          borderBottom: '5px solid #fff',
          textAlign: 'center'
        }
      }
    };
  },
  mounted() {
    console.log('lib view mounted');
    Services.getCards(() => {
        this.loading = false;
    });
    Services.getCardTypes();
    Services.getMarkets();
  }
};
</script>
<style lang="scss" scoped>
p {
  line-height: 1.2rem;
  margin: 0;
  margin-bottom: 8px;
}

.card-wrap {
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 3px 7px 2px rgba(0, 0, 0, 0.1);
  color: rgb(51, 51, 51);
  font-size: 14px;
  display: flex;
  border: 1px solid #eee;
  padding: 10px;
  flex-flow: row nowrap;
  width: calc(25% - 20px);
  text-decoration: none;
  transition: all 0.2s;
  margin: 10px;
  &:hover {
    border: 1px solid #888;
    cursor: pointer;
  }

  @media all and (max-width: 1024px) {
    width: calc(50% - 20px);
  }

  @media all and (max-width: 640px) {
    width: calc(100% - 20px);
  }
}

.card__title {
  font-size: 1.1rem;
  font-family: 'proxima_nova_ltsemibold';
}

.toggle-cards {

    @media all and (min-width:641px){
        right: 2rem;
        top: 6rem;
        position: absolute;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/views/CardLibrary.vue